import Vue from 'vue'
import Vuex from 'vuex'
import {
  login as loginApi,
  removeSuppliers as removeSuppliersApi,
  fetchAuthToken as fetchAuthTokenApi,
  listSuppliers as listSuppliersApi,
  uploadSuppliers as uploadSuppliersApi,
  uploadSuppliersOverwrite as uploadSuppliersOverwriteApi,
  addSupplier as addSupplierApi,
  updateSupplier as updateSupplierApi,
  addLetter as addLetterApi,
  updateLetter as updateLetterApi,
  listLetters as listLettersApi,
  queryYTJ as quetyYTJApi,
  downloadLetterPDF as downloadLetterPDFApi,
  removeLetter as removeLetterApi,
  listLettersSimple as listLettersSimpleApi,
  getLetterAttachment as getLetterAttachmentApi,
  sendSupplierLetter as sendSupplierLetterApi,
  sendSupplierEmail as sendSupplierEmailApi,
  listContract as listContractApi,
  importSuppliers as importSuppliersApi,
  checkImportingSuppliersStatus as checkImportingSuppliersStatusApi,
  sendExampleEmail as sendExampleEmailApi,
  getSession,
  deleteSession as deleteSessionApi
} from '../client'
Vue.use(Vuex)


export default new Vuex.Store({
  strict: true,
  state: {
    user: {
      userData: null,
      userAddresses: [],
      authToken: null,
      userContracts: []
    },
  },
  mutations: {
    SET_USER_DATA(state, data) {
      state.user.userData = data
      const { TransferID, TransferKey } = data
      localStorage.setItem("user", JSON.stringify({ TransferID, TransferKey }))
    },
    SET_USER_ADDRESSES(state, data) {
      state.user.userAddresses = data
    },
    SET_USER_CONTRACTS(state, data) {
      state.user.userContracts = data
    },
    SET_AUTH_TOKEN(state, data) {
      state.user.authToken = data
    },
    DELETE_SESSION(state, data) {
      state.user.authToken = null
      state.user.userAddresses = []
      state.user.userData = null
      localStorage.removeItem("user")
    },

    SET_LOCALE(state, data) {
      state.i18n.locale = data
    }
  },
  actions: {
    login({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        loginApi(params).then(response => {
          let userData = {}
          let userAddress = []
          let user = {}

          if (Array.isArray(response)) {
            user = response.shift()
            userAddress = response.map(i => {
              return i.Value.reduce((acc, curr) => {
                acc[curr["@type"]] = curr["$"] || ""
                return acc
              }, {})
            })
            commit('SET_USER_ADDRESSES', userAddress)
          } else {
            Vue.notify({
              type: "warn",
              text: Vue.i18n.translate("letters.userAddressMissing"),
              duration: 10000
            })
            user = response
          }

          userData = user.Value.reduce((acc, curr) => {
            acc[curr["@type"]] = curr["$"] || ""
            return acc
          }, {})
          commit('SET_USER_DATA', userData)
          const { TransferID, TransferKey, UniqueCompanyID } = userData
          dispatch('fetchAuthToken', { TransferID, TransferKey }).then(tokenRes => {
            dispatch('listContract', { TransferID, TransferKey, UniqueCompanyID })
            resolve(tokenRes)
          }).catch(error => {
            reject(error)
          })


        }).catch(error => {
          reject(error)
        })

      })

    },
    async listContract({ commit }, { TransferID, TransferKey, UniqueCompanyID }) {
      try {
        let arr = await listContractApi({ TraID: TransferID, tkey: TransferKey, cid: UniqueCompanyID })
        let contracts = arr.map(c => {
          return c.Value.reduce((acc, curr) => {
            acc[curr.type] = curr["_@ttribute"] || ""
            return acc
          }, {})
        })
        commit('SET_USER_CONTRACTS', contracts)
      } catch (error) {
        console.log(error)
      }
    },
    listSuppliers({ commit }) {
      return listSuppliersApi()
    },
    importSuppliers({ commit }) {
      return importSuppliersApi()
    },
    checkImportingSuppliersStatus({ commit }) {
      return checkImportingSuppliersStatusApi()
    },
    setSuppliers({ commit }, data) {
      commit('SET_SUPPLIERS', data)
    },
    removeSuppliers({ commit }, req) {
      return removeSuppliersApi(req)
    },
    addSupplier({ commit }, req) {
      return addSupplierApi(req)
    },
    updateSupplier({ commit }, req) {
      return updateSupplierApi(req)
    },
    listLetters({ commit }) {
      return listLettersApi()
    },
    getLetterAttachment({ commit }, letterId) {
      return getLetterAttachmentApi(letterId)
    },
    listLettersSimple({ commit }) {
      return listLettersSimpleApi()
    },
    addLetter({ commit }, req) {
      return addLetterApi(req)
    },
    sendExample({ commit }, req) {
      return sendExampleEmailApi(req)
    },
    removeLetter({ commit }, req) {
      return removeLetterApi(req)
    },
    updateLetter({ commit }, req) {
      return updateLetterApi(req)
    },
    downloadLetterPDF({ commit }, req) {
      return downloadLetterPDFApi(req)
    },
    sendLetter({ commit }, req) {
      return sendSupplierLetterApi(req)
    },
    sendEmail({ commit }, req) {
      return sendSupplierEmailApi(req)
    },
    queryYTJ({ commit }, bid) {
      return quetyYTJApi(bid)
    },
    setLocale({ commit }, data) {
      commit('SET_LOCALE', data)
      localStorage.setItem("locale", data)
    },
    async fetchAuthToken({ commit }, { TransferID, TransferKey }) {
      try {
        let token = await fetchAuthTokenApi(TransferID, TransferKey)
        commit('SET_AUTH_TOKEN', token.token)
        return true
      } catch (error) {
        console.log(error)
        throw error
      }

    },
    loadSession({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        let user = localStorage.getItem("user")
        if (user) {
          user = JSON.parse(user)
          getSession({ TraID: user.TransferID, tkey: user.TransferKey }).then(response => {
            let userData = {}
            let userAddress = []
            let user = {}

            if (Array.isArray(response)) {
              user = response.shift()
              userAddress = response.map(i => {
                return i.Value.reduce((acc, curr) => {
                  acc[curr["@type"]] = curr["$"] || ""
                  return acc
                }, {})
              })
              commit('SET_USER_ADDRESSES', userAddress)
            } else {
              Vue.notify({
                type: "warn",
                text: Vue.i18n.translate("letters.userAddressMissing"),
                duration: 10000
              })
              user = response
            }

            userData = user.Value.reduce((acc, curr) => {
              acc[curr["@type"]] = curr["$"] || ""
              return acc
            }, {})
            commit('SET_USER_DATA', userData)
            const { TransferID, TransferKey, UniqueCompanyID } = userData
            dispatch('fetchAuthToken', { TransferID, TransferKey }).then(tokenRes => {
              dispatch('listContract', { TransferID, TransferKey, UniqueCompanyID })
              resolve(tokenRes)
            }).catch(error => {
              reject(error)
            })


          }).catch(error => {
            reject(error)
          })
        }

      })
    },
    uploadSuppliers({ commit }, request) {
      return uploadSuppliersApi(request)
    },
    deleteSession({ commit, getters }) {
      const { TransferID, TransferKey } = getters.userData
      deleteSessionApi({ TraID: TransferID, tkey: TransferKey })
      commit('DELETE_SESSION')
    },
    uploadSuppliersOverwrite({ commit }, request) {
      return uploadSuppliersOverwriteApi(request)
    }
  },
  modules: {
  },
  getters: {
    authToken: state => {
      return state.user.authToken
    },
    userData: state => {
      return state.user.userData
    },
    userAddresses: state => {
      return state.user.userAddresses
    },
    isLoggedIn: state => {
      return state.user.userData !== null && state.user.authToken !== null
    },
    userContracts: state => {
      return state.user.userContracts
    }
  }
})
